<div class="floating-text">
    <p class="mb-0">Copyright {{ today | date:'y'}} © BIS Open API {{layout.getTenant()}} v.1.6</p>
</div>